<template>
    <span class="skin-activity-artwork" :data-activity-art="name" :style="position" aria-hidden="true" />
</template>

<script>
const positions = { envelopeClosed: '0% 0%', envelopeOpen: '100% 0%', calendar: '0% 50%', moneybag: '100% 50%', rain: '0% 100%', promotion: '100% 100%' }
export default {
    name: 'ActivityArtwork',
    props: { name: { type: String, default: 'envelopeClosed' } },
    computed: {
        position() { return { backgroundPosition: positions[this.name] || positions.envelopeClosed } }
    }
}
</script>

<style scoped>
.skin-activity-artwork { display: block; width: 100%; max-width: 100%; aspect-ratio: 1; background-image: var(--skin-activity-scenes); background-size: 200% 300%; background-repeat: no-repeat; pointer-events: none; }
</style>
